import React, { forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-regular-svg-icons";
import "./emailBuilderMobileToolsButton.scss";

interface IEmailBuilderMobileToolsButtonProps {
  open: boolean;
  onClick: () => void;
  ariaLabel: string;
}

export const EmailBuilderMobileToolsButton = forwardRef<
  HTMLButtonElement,
  IEmailBuilderMobileToolsButtonProps
>((props, ref) => {
  const { open, onClick, ariaLabel } = props;

  return (
    <button
      ref={ref}
      type="button"
      className="email-builder-mobile-tools-button"
      aria-label={ariaLabel}
      aria-expanded={open}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faBars} aria-hidden="true" />
    </button>
  );
});

EmailBuilderMobileToolsButton.displayName = "EmailBuilderMobileToolsButton";
